import { Component } from "react";
import { withStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent/DialogContent";
import DialogActions from "@mui/material/DialogActions/DialogActions";
import "./PreviewImage.css";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import ValidateIcon from "@mui/icons-material/Check";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";

const styles = {
    icon: {
        color: "#D50000",
    },
    appBar: {
        position: "relative",
        marginBottom: "10px",
    },
    flex: {
        flex: 1,
    },
};

class PreviewImage extends Component {
    render() {
        const { classes } = this.props;

        return (
            <Dialog fullScreen onClose={this.props.close.bind(this)} aria-labelledby="simple-dialog-title" open={true}>
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton color="inherit" onClick={this.props.close} aria-label="Close">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" color="inherit" className={classes.flex}>
                            Aperçu
                        </Typography>
                    </Toolbar>
                </AppBar>
                <Toolbar />
                <DialogContent className="container">
                    <img src={this.props.image} alt="Aperçu" />
                </DialogContent>
                {!this.props.disabled ? (
                    <DialogActions>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                            <IconButton onClick={this.props.delete}>
                                <DeleteIcon className={classes.icon} />
                            </IconButton>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-6 right without-side-padding">
                            <IconButton onClick={this.props.close}>
                                <ValidateIcon />
                            </IconButton>
                        </div>
                    </DialogActions>
                ) : null}
            </Dialog>
        );
    }
}

export default withStyles(styles)(PreviewImage);
